import { render, staticRenderFns } from "./order-card.vue?vue&type=template&id=0b417484&scoped=true"
import script from "./order-card.vue?vue&type=script&lang=js"
export * from "./order-card.vue?vue&type=script&lang=js"
import style0 from "./order-card.vue?vue&type=style&index=0&id=0b417484&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b417484",
  null
  
)

export default component.exports